import * as React from "react";
import { ScrollView } from "react-native";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { StackActions, useNavigation } from "@react-navigation/native";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "app/shared/util/media-query";
import { StackSpacing } from "@components/spacing";
import { useTranslation } from "react-i18next";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { ButtonFormActions, ButtonRow, HeaderSuccessTitle } from "app/shared/components/screen-success/screen-success";
import { useDispatch, useSelector } from "react-redux";
import ScreenNameType from "@navigation/nav-screens";
import { getTermDepositStatementSelector } from "../reducer/selectors";
import GlobalViewShot, { GlobalViewShotRef } from "app/shared/components/global-view-shot/global-viewshot.web";
import { fetchListAccountRequest } from "app/modules/account-management/reducer/actions";
import { pushCleverTapEvent } from "app/shared/util/app-flyer";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";
import moment from "moment";

const TermDepositStatementSuccess = () => {
  const { dispatch } = useNavigation();
  const { t } = useTranslation();
  const dispatchStore = useDispatch();
  const isDesktop = useDesktopMediaQuery();
  const globalViewShotRef = React.useRef<GlobalViewShotRef>(null);

  const termDepositStore = useSelector(getTermDepositStatementSelector);
  const contactId = useSelector(getContactIdSelector);

  const onPressGoHome = () => {
    eventPushCleverTap("Trang chủ");
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const onPressGoBack = () => {
    eventPushCleverTap("Giao dịch khác");
    dispatch(StackActions.replace(ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => onPressGoHome(),
    },
    {
      name: t("FUNC_TIET_KIEM"),
      onPressSubtitle: () => onPressGoBack(),
    },
    {
      name: t("SAVING_TAT_TOAN"),
      onPressSubtitle: () => {},
    },
  ];

  const eventPushCleverTap = (action?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(action);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const onPressPrint = () => {
    eventPushCleverTap("In biên lai");
    globalViewShotRef.current?.printViewShot();
  };

  const onPressShare = () => {
    eventPushCleverTap("Tải về");
    globalViewShotRef.current?.takeViewShot();
  };

  const handlerParamsCleverTap = (cta?: string) => {
    console.log("handlerParamsCleverTap");
    let term = termDepositStore.dataCreate?.ACCOUNT_DEBIT?.FDTERM || "";
    if (term !== "") {
      term = term.replace("-", "");
    }
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_cta: cta || "",
      ct_final_settlement_product: termDepositStore.dataCreate?.ACCOUNT_DEBIT?.PRODUCTCODE,
      ct_final_settlement_term: term,
      ct_final_settlement_total_amount: termDepositStore.dataCreate?.ACCOUNT_DEBIT?.CURRENTBALANCE || "",
      ct_final_settlement_branch: termDepositStore.dataCreate?.ACCOUNT_DEBIT?.BRANCH_CODE || "",
      ct_final_settlement_interest_receive: termDepositStore?.responseCreate?.EBACCOUNT_DEPOSITS?.INTEREST_AMOUNT || "",
      ct_transaction_time:
        moment(String(termDepositStore.responseConfirm?.EBACCOUNT_DEPOSITS?.OPEN_DATE), "YYYYMMDD").format("DD/MM/YYYY") || "",
      ct_final_settlement_status: "success",
    };

    return {
      eventNameCT: "ct_final_settlement_success",
      paramsCT: param,
    };
  };

  React.useEffect(() => {
    eventPushCleverTap();
    dispatchStore(fetchListAccountRequest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchStore]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("SAVING_TAT_TOAN")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? 150 : 0}>
          <StepProcessUniversal currentSteps={3} />
          <StackSpacing size="medium" />
          <GlobalViewShot ref={globalViewShotRef}>
            <HeaderSuccessTitle
              headlineText={t("SAVING_TAT_TOAN_STK_THANH_CONG")}
              headlineTwoText={t("SAVING_SO_SO") + ": " + termDepositStore?.dataCreate?.ACCOUNT_DEBIT?.ACCOUNTNO}
              amount={termDepositStore?.dataCreate?.ACCOUNT_DEBIT?.CURRENTBALANCE}
            />
          </GlobalViewShot>
          <StackSpacing size="large" />
          <ButtonFormActions onPressPrint={onPressPrint} onPressShare={onPressShare} />
          <ButtonRow onPressGoBack={onPressGoBack} onPressGoHome={onPressGoHome} />
        </Block>
      </ScrollView>
    </Block>
  );
};

export default TermDepositStatementSuccess;
